module.exports = __webpack_public_path__ + "static/img/grac-oidd-competition-pt02.6013f6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/grac-oidd-competition-pt02.jpg
// module id = rt89
// module chunks = 0